import React, { useMemo } from 'react';
import { Redirect } from 'react-router';
import { ROUTES } from 'App/Routes/constants';
import {
  IdentityAlert,
  PendingTrialPeriodAlertPage,
} from 'commons/components/IdentityAlert';
import { StoreFlag } from 'commons/enums';
import {
  useCreditOffer,
  useHasTransactions,
  useIdentityValidation,
  useStoreFlag,
} from 'commons/hooks';
import Home from 'domains/Home/Home';
import HomeSkeleton from 'domains/Home/HomeSkeleton';
import ActiveContractBanner from '../Lending/ActiveContractBanner';
import OfferBanner from '../Lending/OfferBanner';

function HomeArgentina(): JSX.Element {
  const { hasTransactions, isLoading: transactionsLoading } =
    useHasTransactions();
  const { data: identityValidationData } = useIdentityValidation();
  const { data: creditOffer } = useCreditOffer();
  const { enabled: lendingNpLockInEnabled } = useStoreFlag(
    StoreFlag.NpLockInByLending,
  );

  const getAlertsComponent = useMemo(() => {
    const validationStatus = identityValidationData?.status;
    const validationUpdatedAt = identityValidationData?.updatedAt;
    const kycDocumentsErrors = identityValidationData?.kycDocumentErrors;
    const trialPeriod = identityValidationData?.trialPeriod;
    const blockedTrialPeriod = identityValidationData?.blockedTrialPeriod;
    const validationStatusDetail = identityValidationData?.statusDetail;

    if (!validationStatus || !validationUpdatedAt) {
      return null;
    }

    return (
      <IdentityAlert
        identityStatus={validationStatus}
        updatedAt={validationUpdatedAt}
        kycDocumentsErrors={kycDocumentsErrors ?? []}
        trialPeriod={trialPeriod}
        page={PendingTrialPeriodAlertPage.HOME}
        blockedTrialPeriod={blockedTrialPeriod}
        statusDetail={validationStatusDetail}
      />
    );
  }, [identityValidationData]);

  const bannerComponent = useMemo(() => {
    const showOfferBanner = creditOffer?.canOffer && !lendingNpLockInEnabled;
    const showActiveContractBanner =
      creditOffer?.canOffer && lendingNpLockInEnabled;

    if (showOfferBanner) return <OfferBanner />;
    if (showActiveContractBanner) return <ActiveContractBanner />;

    return <></>;
  }, [lendingNpLockInEnabled, creditOffer?.canOffer]);

  if (transactionsLoading) return <HomeSkeleton />;

  if (!hasTransactions) return <Redirect to={ROUTES.LANDING} />;

  return (
    <Home
      alertsComponent={getAlertsComponent}
      bannerComponent={bannerComponent}
    />
  );
}

HomeArgentina.Skeleton = HomeSkeleton;
export default HomeArgentina;
